<xemex-chart
  [datasets]="datasets()"
  [labels]="labels()"
  [loading]="loading()"
  [options]="options()"
  [unit]="unit()"
></xemex-chart>
